import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Button, COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {AutocompleteWrapper} from 'app/components/admin/AutocompleteWrapper';
import {string} from 'prop-types';
import {getTopEleven, putTopEleven} from 'app/services/api';
import {Snackbar} from '@mui/material';
import {Alert} from '@mui/material';

const Wrapper = styled.div`
  padding: ${SIZES['16']};
  width: 100%;
  max-width: 31.25rem;
  background-color: ${COLORS.white};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${SIZES['16']};
  width: 100%;
`;

const TopElevenForm = ({id, header}) => {
  const [open, setOpen] = useState(false);
  const [putError, setPutError] = useState(null);
  const [topEleven, setTopEleven] = useState({
    Torwart: [],
    Abwehr: [],
    Mittelfeld: [],
    Angriff: [],
  });
  const [error, setError] = useState({
    Torwart: false,
    Abwehr: false,
    Mittelfeld: false,
    Angriff: false,
  });

  useEffect(() => {
    getTopEleven(id).then((response) => {
      const players = response.data.topEleven;
      const getPlayersByPosition = (players, position) =>
        players.filter((player) => player.position === position).map((player) => player.player);

      setTopEleven({
        Torwart: getPlayersByPosition(players, 'Torwart'),
        Abwehr: getPlayersByPosition(players, 'Abwehr'),
        Mittelfeld: getPlayersByPosition(players, 'Mittelfeld'),
        Angriff: getPlayersByPosition(players, 'Angriff'),
      });
    });
  }, []);

  const handleValueChange = (values, position) => {
    setTopEleven({...topEleven, [position]: values});
  };

  const handleValueDelete = (slug, position) => {
    const newValues = topEleven[position].filter((value) => value.slug !== slug);
    setTopEleven({...topEleven, [position]: newValues});
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    let testError = {
      Torwart: topEleven.Torwart.length !== 1,
      Abwehr: topEleven.Abwehr.length !== 3,
      Mittelfeld: topEleven.Mittelfeld.length !== 4,
      Angriff: topEleven.Angriff.length !== 3,
    };

    setError(testError);

    const setPositionValues = (values, position) => {
      return values.map((value) => {
        return {
          player: value,
          position,
        };
      });
    };

    const topElevenPositions = Object.keys(topEleven).map((position) =>
      setPositionValues(topEleven[position], position)
    );

    if (Object.values(testError).every((item) => !item)) {
      const elevenOfTheYear = [].concat(...topElevenPositions);
      putTopEleven(id, elevenOfTheYear)
        .then(() => {
          setOpen(true);
        })
        .catch((error) => {
          setOpen(true);
          setPutError(error);
        });
    }
  };

  return (
    <Wrapper>
      <Typography variant='subheading'>{header}</Typography>
      <AutocompleteWrapper
        label='Torwart'
        error={error.Torwart}
        values={topEleven.Torwart}
        helperText='Es darf nur ein Torwart gewählt werden.'
        onValueChange={(e, values) => handleValueChange(values, 'Torwart')}
        onValueDelete={(slug) => handleValueDelete(slug, 'Torwart')}
      />
      <AutocompleteWrapper
        label='Abwehr'
        error={error.Abwehr}
        values={topEleven.Abwehr}
        helperText='Es müssen genau drei Abwehrspieler gewählt werden.'
        onValueChange={(e, values) => handleValueChange(values, 'Abwehr')}
        onValueDelete={(slug) => handleValueDelete(slug, 'Abwehr')}
      />
      <AutocompleteWrapper
        label='Mittelfeld'
        error={error.Mittelfeld}
        values={topEleven.Mittelfeld}
        helperText='Es müssen genau vier Mittelfeldspieler gewählt werden.'
        onValueChange={(e, values) => handleValueChange(values, 'Mittelfeld')}
        onValueDelete={(slug) => handleValueDelete(slug, 'Mittelfeld')}
      />
      <AutocompleteWrapper
        label='Angriff'
        error={error.Angriff}
        values={topEleven.Angriff}
        helperText='Es müssen genau drei Angreifer gewählt werden.'
        onValueChange={(e, values) => handleValueChange(values, 'Angriff')}
        onValueDelete={(slug) => handleValueDelete(slug, 'Angriff')}
      />
      <ButtonContainer>
        <Button label='Speichern' onClick={handleSubmit} />
      </ButtonContainer>
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}>
        {putError ? (
          <Alert onClose={handleClose} severity='error'>
            Beim Speichern der 11 des Jahres ist ein Fehler aufgetreten.
          </Alert>
        ) : (
          <Alert onClose={handleClose} severity='success'>
            11 des Jahres {id} erfolgreich gespeichert.
          </Alert>
        )}
      </Snackbar>
    </Wrapper>
  );
};

TopElevenForm.propTypes = {
  id: string.isRequired,
  header: string.isRequired,
};

export {TopElevenForm};
